// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./$.export');

$export($export.P, 'Array', {copyWithin: require('./$.array-copy-within')});

require('./$.add-to-unscopables')('copyWithin');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es6.array.copy-within.js
 ** module id = 89
 ** module chunks = 0
 **/